import dayjs from 'dayjs'
import * as R from 'ramda'
import {
  getDateRange,
  getDayjsToday,
  getDefaultDateRange,
  getWorkspaceAwareStartOfWeek,
  getWorkspaceAwareEndOfWeek,
  getWorkspaceWeekStartDay,
} from 'libs/date'

export function generateDateRanges(
  isSupportAllTime = false,
  weekStartDay = getWorkspaceWeekStartDay()
) {
  const dateRanges = [
    {
      label: 'Today',
      dateRange: [
        getDayjsToday().startOf('day').utc().format(),
        getDayjsToday().endOf('day').utc().format(),
      ],
    },
    {
      label: 'Yesterday',
      dateRange: [
        getDayjsToday().subtract(1, 'day').startOf('day').utc().format(),
        getDayjsToday().subtract(1, 'day').endOf('day').utc().format(),
      ],
    },
    { label: 'Last 7 days', dateRange: getDateRange({ days: 7 }) },
    { label: 'Last 14 days', dateRange: getDateRange({ days: 14 }) },
    {
      label: 'Last 30 days',
      dateRange: getDateRange({ days: 30 }),
    },
    {
      label: 'Last 90 days',
      dateRange: getDateRange({ days: 90 }),
      isDefault: true,
    },
    {
      label: 'Last 180 days',
      dateRange: getDateRange({ days: 180 }),
      isDefault: true,
    },
    {
      label: 'Last 365 days',
      dateRange: getDateRange({ days: 365 }),
    },
    {
      label: 'This week',
      dateRange: [
        getWorkspaceAwareStartOfWeek(getDayjsToday(), weekStartDay).utc().format(),
        getDayjsToday().endOf('day').utc().format(),
      ],
    },
    {
      label: 'Last week',
      dateRange: [
        getWorkspaceAwareStartOfWeek(getDayjsToday().subtract(1, 'week'), weekStartDay)
          .utc()
          .format(),
        getWorkspaceAwareEndOfWeek(getDayjsToday().subtract(1, 'week'), weekStartDay)
          .utc()
          .format(),
      ],
    },
    {
      label: 'This month',
      dateRange: [
        getDayjsToday().startOf('month').utc().format(),
        getDayjsToday().endOf('day').utc().format(),
      ],
    },
    { label: 'Last month', dateRange: getDateRange({ months: [2, 1] }) },
    {
      label: 'This quarter',
      dateRange: [
        getDayjsToday().startOf('quarter').utc().format(),
        getDayjsToday().endOf('day').utc().format(),
      ],
    },
    { label: 'Last quarter', dateRange: getDateRange({ quarters: [2, 1] }) },
    {
      label: 'This year',
      dateRange: [
        getDayjsToday().startOf('year').utc().format(),
        getDayjsToday().endOf('day').utc().format(),
      ],
    },
    { label: 'Last year', dateRange: getDateRange({ years: [2, 1] }) },
  ]

  if (isSupportAllTime) {
    dateRanges.push({
      label: 'All time',
      dateRange: [
        dayjs('1983-01-01').startOf('day').utc().format(),
        getDayjsToday().endOf('day').utc().format(),
      ],
    })
  }

  return dateRanges
}

export function getDateRangeByDateFilterType(
  dateRangeType,
  weekStartDay = getWorkspaceWeekStartDay()
) {
  const presetDateRange = generateDateRanges(true, weekStartDay)
  const selectedPresetIndex = convertFilterTypeToIndex(dateRangeType)
  const [startDate, endDate] = presetDateRange[selectedPresetIndex].dateRange

  return [startDate, endDate]
}

export function getInitialDateRange() {
  return getDefaultDateRange()
}

export default function convertIndexToFilterType(index) {
  const indexToFilterType = {
    0: 8, // Today
    1: 17, // Yesterday
    2: 3, // Last 7 days
    3: 9, // Last 14 days
    4: 4, // Last 30 days
    5: 5, // Last 90 days
    6: 10, // Last 180 days
    7: 6, // Last 365 days
    8: 11, // This week
    9: 12, // Last week
    10: 1, // This month
    11: 2, // Last month
    12: 13, // This quarter
    13: 14, // Last quarter
    14: 15, // This year
    15: 16, // Last year
    16: 7, // All time
  }

  const absoluteDateRange = 0
  return R.defaultTo(absoluteDateRange, R.prop(index, indexToFilterType))
}

export function convertFilterTypeToIndex(filterType) {
  const filterTypeToIndex = {
    8: 0, // Today
    17: 1, // Yesterday
    3: 2, // Last 7 days
    9: 3, // Last 14 days
    4: 4, // Last 30 days
    5: 5, // Last 90 days
    10: 6, // Last 180 days
    6: 7, // Last 365 days
    11: 8, // This week
    12: 9, // Last week
    1: 10, // This month
    2: 11, // Last month
    13: 12, // This quarter
    14: 13, // Last quarter
    15: 14, // This year
    16: 15, // Last year
    7: 16, // All time
  }
  const uncheckedPresetIndex = null
  return R.defaultTo(uncheckedPresetIndex, R.prop(filterType, filterTypeToIndex))
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/shared/components/DateRangePicker/utils.js